export default "__VITE_ASSET__DVA6ml83__"